import styled, { CSSProperties } from 'styled-components';

import {
  margin,
  MarginProps,
  flex,
  FlexProps,
  gap,
  GapProps,
  rect,
  RectProps,
} from '../../../components/styles';

type Props = {
  column?: 'two' | 'three';
};

const Root = styled.div<Props & MarginProps & FlexProps & GapProps & RectProps>`
  display: grid;
  gap: ${({ theme }) => theme.spaces.xxl};
  grid-template-columns: ${({ column }) =>
    column == 'two' ? `repeat(2, 1fr)` : `repeat(3, 1fr)`};
  justify-content: space-between;
  flex-wrap: wrap;
  ${margin};
  ${flex};
  ${gap};
  ${rect};

  ${({ theme }) =>
    theme.screen.sp({
      gridTemplateColumns: '1fr',
    })}
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spaces.l};
`;

export const Columns = Object.assign(Root, { Item });
